import { jsxs, jsx } from "react/jsx-runtime";
const IconRedoSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M21.923 9.382a1 1 0 0 0-.217-1.09l-4.999-4.999a1 1 0 1 0-1.414 1.414L18.586 8H8.5C4.916 8 2 10.916 2 14.5S4.916 21 8.5 21a1 1 0 1 0 0-2C6.019 19 4 16.981 4 14.5S6.019 10 8.5 10h10.086l-3.293 3.293a1 1 0 1 0 1.414 1.414l4.999-4.999a1 1 0 0 0 .217-.326Z" })
    ]
  }
);
export {
  IconRedoSvg
};
